export default __webpack_public_path__ + "static/yvonne-02c5e86b208c002398e8d60622e4f547.jpg";